import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, rgba, setElevation } from "@similarweb/styles";
import { IconButton, Tooltip } from "@similarweb/ui-components";
import { Box, Flex } from "@similarweb/ui-components/foundations";

import { COLUMN_CARD_HEIGHT } from "app/pages/sales-intelligence/common-components/column-picker/constants";
import { withSWReactIconFillColor } from "app/pages/sales-intelligence/common-components/styles";

export const StyledIconButtonWrapper = styled.div`
    border-radius: 50%;
`;

export const StyledRequiredIconWrapper = styled.div`
    padding: 0 4px 0 2px;
`;

export const StyledCloseIconWrapper = styled.div`
    ${SWReactIcons} {
        transform: rotate(45deg);
    }
`;

export const StyledIconButton = styled(IconButton)`
    ${withSWReactIconFillColor(colorsPalettes.bluegrey[600])};

    background-color: transparent;

    ${SWReactIcons} {
        path {
            transition: fill 0.2s ease-in-out;
        }
    }

    &:hover {
        background-color: ${rgba(colorsPalettes.carbon[200], 0.2)};

        ${SWReactIcons} svg path {
            fill: ${colorsPalettes.bluegrey[600]};
        }
    }
`;

export const StyledUpgradeButton = styled(IconButton)`
    background-color: transparent;

    ${SWReactIcons} svg path {
        fill: ${colorsPalettes.indigo[300]};
    }

    &:hover {
        background-color: ${rgba(colorsPalettes.carbon[200], 0.2)};

        ${SWReactIcons} svg path {
            fill: ${colorsPalettes.indigo[300]};
        }
    }
`;

export const StyledIcon = styled(SWReactIcons)`
    padding: 8px;
`;

export const StyledColumnOption = styled.div`
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;

    background-color: ${colorsPalettes.bluegrey[100]};

    width: 100%;
    height: ${COLUMN_CARD_HEIGHT}px;

    box-sizing: border-box;
    padding: 5px 16px;
    border-radius: 6px;

    transition: box-shadow 200ms ease-in-out;

    /* Keyed on the action button rather than the row, which is what the previous Web Animations
       implementation hovered on. */
    &:has(${StyledIconButtonWrapper}:hover) {
        ${setElevation("Z1_hover")};
    }

    @media (prefers-reduced-motion: reduce) {
        transition: none;
    }
`;

export const StyledDragIcon = styled(SWReactIcons)`
    margin-left: -8px;
    fill: ${colorsPalettes.midnight[100]};
`;

export const StyledSelectedColumnOption = styled(StyledColumnOption)`
    ${StyledIconButton} {
        transition: opacity 0.2s ease-in-out;
        opacity: 0;
    }

    &:hover {
        ${StyledIconButton} {
            opacity: 1;
        }

        ${StyledDragIcon} {
            fill: ${colorsPalettes.bluegrey[600]};
        }
    }
`;

export const StyledFlexRow = styled(Flex)`
    align-items: center;
    flex: 1;
    min-width: 0;
`;

export const StyledActionsContainer = styled(Flex)`
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
`;

export const StyledTooltip = styled(Tooltip)`
    && {
        min-height: 215px;
        max-width: 284px;
        background-color: ${colorsPalettes.carbon["0"]};
        color: ${colorsPalettes.carbon["500"]};
        align-content: center;
    }
`;

export const StyledTooltipContent = styled(Box)`
    padding-top: 8px;
    padding-bottom: 8px;
    height: 231px;
    align-content: center;
`;
